/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type SocialAnamnesisDtoMaritalStatus =
  (typeof SocialAnamnesisDtoMaritalStatus)[keyof typeof SocialAnamnesisDtoMaritalStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SocialAnamnesisDtoMaritalStatus = {
  UNKNOWN: 'UNKNOWN',
  SINGLE: 'SINGLE',
  MARRIED: 'MARRIED',
  WIDOWED: 'WIDOWED',
  DIVORCED: 'DIVORCED',
  UNMARRIED: 'UNMARRIED',
  REGISTERED_PARTNERSHIP: 'REGISTERED_PARTNERSHIP',
  DISSOLVED_PARTNERSHIP: 'DISSOLVED_PARTNERSHIP',
} as const;
